/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diagram_Render_Error_TitleInputs */



/**
* | output |
* | --- |
* | "Couldn't render diagram" |
*
* @param {Diagram_Render_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diagram_render_error_title = /** @type {((inputs?: Diagram_Render_Error_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diagram_Render_Error_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diagramm konnte nicht gerendert werden")
	return /** @type {LocalizedString} */ ("Couldn't render diagram")
});